<template>
    <div>

        <div v-html="makeSeasonsRentalPrices()">

        </div>

    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'seasonprices',
    	props: {
    		pricelist: String
    	},
    	data: function() {
    		return {
    			groupedSeasons: [],
    			serviceByFinalCleaning: [],
    			priceListFilteredByRent: [],
    			serviceByBookingFee: [],
    			groupedSeasonsWithPrice: []

    		};
    	},
    	mounted: function() {
    		var pricelist = JSON.parse(this.pricelist);
    		//console.log('Pricelist::', pricelist);


    		/**
    		 * 1. filter all elements, which are of type 'RENT', are no surcharge and element has lines array
    		 */
    		const priceListFilteredByRent = pricelist.filter((priceListElement) => {
    			return priceListElement.service.type && priceListElement.service.type === 'RENT' && !priceListElement.service.surcharge && priceListElement.lines;
    		});

    		this.priceListFilteredByRent = priceListFilteredByRent;
    		//console.log('priceListFilteredByRent', priceListFilteredByRent);

    		if (priceListFilteredByRent) {
    			const priceListFilteredByRentLines = priceListFilteredByRent[0].lines;
    			// console.log('priceListFilteredByRentLines', priceListFilteredByRentLines);

    			/**
    			 * 2. reduce lines of filtered elements to only needed properties
    			 */
    			const priceListFilteredByRentMappedLines = priceListFilteredByRentLines.map(({
    				season, calculation, condition, fromdate, tilldate, value
    			}) => {
    				return {
    					season, calculation, condition, fromdate, tilldate, value
    				};
    			});
    			// console.log('priceListFilteredByRentMappedLines', priceListFilteredByRentMappedLines);

    			/**
    			 * 3. get grouped season of line elements
    			 */

    			/**
    			 * 3.1 get unique season names
    			 */
    			let seasonNames = [];
    			priceListFilteredByRentMappedLines.forEach(({
    				season
    			}) => {
    				if (!seasonNames.includes(season)) {
    					seasonNames.push(season);
    				}
    			});
    			// console.log('seasonNames', seasonNames);

    			/**
    			 * 3.2 group season periods for seasons
    			 */
    			let groupedSeasons = [];
    			seasonNames.forEach((seasonName) => {
    				const linesBySeasonName = priceListFilteredByRentMappedLines.filter(({
    					season
    				}) => {
    					return season === seasonName;
    				});
    				// console.log('linesBySeasonName', linesBySeasonName);

    				let seasonWithPeriods = {
    					name: seasonName,
    					seasonPeriods: []
    				};
    				linesBySeasonName.forEach(({
    					fromdate, tilldate
    				}) => {
    					const fromdateFormatted = new Date(fromdate).toLocaleDateString('de-DE', {
    						year: 'numeric',
    						month: '2-digit',
    						day: '2-digit'
    					});
    					const tilldateFormatted = new Date(tilldate).toLocaleDateString('de-DE', {
    						year: 'numeric',
    						month: '2-digit',
    						day: '2-digit'
    					});

    					const period = `${fromdateFormatted} - ${tilldateFormatted}`;
    					seasonWithPeriods.seasonPeriods.push(period);
    				});
    				if (seasonWithPeriods.seasonPeriods) {
    					groupedSeasons.push(seasonWithPeriods);
    				}
    			});

    			this.groupedSeasons = groupedSeasons;
    			//console.log('groupedSeasons', groupedSeasons);

    			/**
    			 * 4 filter cleaningprices
    			 */

    			const priceListFilteredByFinalCleaning = pricelist.filter((filterListItem) => {
    				return filterListItem.service.type && filterListItem.service.type === 'FINALCLEANING' && filterListItem.lines;
    			});

    			//console.log('priceListFilteredByFinalCleaning', priceListFilteredByFinalCleaning);

    			const serviceByFinalCleaning = priceListFilteredByFinalCleaning.map((service) => {
    				return {
    					lines: service.lines.map(({
    						calculation, condition, fromdate, tilldate, value
    					}) => {
    						return {
    							calculation, condition, fromdate, tilldate, value
    						}
    					}),
    					serviceName: service.service.name,
    					price: service.price
    				}
    			});
    			this.serviceByFinalCleaning = serviceByFinalCleaning;
    			//console.log('serviceByFinalCleaning', serviceByFinalCleaning);

    			const priceListFilteredByBookingFee = pricelist.filter((filterListItem) => {
    				return filterListItem.service.type && filterListItem.service.type === 'BOOKING_FEE';
    			});

    			//console.log('priceListFilteredByBookingFee ', priceListFilteredByBookingFee);

    			const serviceByBookingFee = priceListFilteredByBookingFee.map((element) => {
    				return {
    					calculation: element.service.calculation,
    					name: element.service.name,
    					perAdult: element.service.perAdult,
    					perBaby: element.service.perBaby,
    					perBeds: element.service.perBeds,
    					perChild: element.service.perChild,
    					price: element.price
    				}
    			});

    			this.serviceByBookingFee = serviceByBookingFee;

    			//console.log('serviceByBookingFee ', serviceByBookingFee);

    			this.makeSeasonsRentalPrices();


    		}

    	},
    	methods: {

    		makeSeasonsRentalPrices: function() {
    			let groupedSeasons = this.groupedSeasons;
    			let serviceByFinalCleaning = this.serviceByFinalCleaning;

    			let groupedSeasonsWithPrice = [];
    			var rentalPrice = 0;
    			var bookingFeePrice = 0;
    			var cleaningPrice = 0;
    			var firstNightPrice = 0;
    			var allNightPrice = 0;
    			var i = -1;
    			var entry = {};
    			groupedSeasons.forEach((season) => {
    				i++;
    				//	console.log(i);
    				rentalPrice = this.calculateRentalPrice(season.name);
    				allNightPrice = rentalPrice;
    				//	console.log('___________________________');
    				//	console.log(season.name);
    				//	console.log('rentalPrice:', rentalPrice);
    				cleaningPrice = this.calculateCleaningPrice(season.seasonPeriods);
    				//	console.log('cleaningPrice:', cleaningPrice);
    				bookingFeePrice = this.calculateBookingFeePrice(season.seasonPeriods);
    				//	console.log('bookingFeePrice:', bookingFeePrice);
    				firstNightPrice = rentalPrice + cleaningPrice + bookingFeePrice;
    				//	console.log('firstNightPrice:', firstNightPrice);
    				//	console.log('allNightPrice:', allNightPrice);
    				//	console.log('___________________________');

    				entry = {
    					'name': season.name,
    					'seasonPeriods': season.seasonPeriods,
    					'firstNightPrice': firstNightPrice > 0 ? firstNightPrice / 100 : 0,
    					'allNightPrice': allNightPrice > 0 ? allNightPrice / 100 : 0
    				}

    				groupedSeasonsWithPrice.push(entry);


    			});



    			//this.groupedSeasonsWithPrice = groupedSeasonsWithPrice;

    			//console.log('groupedSeasonsWithPrice', this.groupedSeasonsWithPrice);

    			return this.makeSeasonTable(groupedSeasonsWithPrice);

    		},



    		calculateRentalPrice: function(seasonName) {
    			if (this.priceListFilteredByRent[0].lines) {
    				var lines = this.priceListFilteredByRent[0].lines;
    				for (let i = 0; i < lines.length; i++) {
    					if (lines[i].season === seasonName) {
    						//  console.log(lines[i].season);
    						//  console.log('DayPrice',lines[i].value);
    						return (lines[i].value * 1);
    					}

    				}
    			}

    		},

    		calculateCleaningPrice: function(seasonPeriods) {
    			if (this.serviceByFinalCleaning[0]) {
    				var data = this.serviceByFinalCleaning[0];
    				if (data.price) {
    					return data.price;
    				} else {
    					var dates = seasonPeriods[0].split(' - ');
    					var startDate = dates[0].split('.');
    					var prices = [];

    					//	console.log('seasonPeriod:', startDate[2]);

    					if (data.lines) {
    						for (let i = 0; i < data.lines.length; i++) {
    							var fromdate = data.lines[i].fromdate.split('-');
    							//	console.log('fromdate:', fromdate[0]);
    							if (fromdate[0] === startDate[2]) {
    								prices.push(data.lines[i].value);
    								//	console.log('CleaningPrice::', data.lines[i].value);
    								return prices[0];
    							} else if (fromdate[0] <= startDate[2]) {
    								prices.push(data.lines[i].value);
    							}

    						}
    						return prices[0];


    					}

    				}
    			}
    		},

    		calculateBookingFeePrice: function(seasonPeriods) {
    			var bookingFeePrice = 0;
    			if (this.serviceByBookingFee[0]) {
    				var data = this.serviceByBookingFee[0];
    				if (data.calculation && data.calculation === 'FLAT') {
    					if (data.price) {
    						bookingFeePrice = data.price;
    					}
    				} else if (data.calculation && data.calculation === 'NIGHT') {
    					if (data.price) {
    						bookingFeePrice = (data.price * 7);
    					}
    				}
    			}

    			return bookingFeePrice;
    		},

    		makeSeasonTable: function(groupedSeasonsWithPrice) {
    			let data = groupedSeasonsWithPrice;
    			//console.log('data::', this.groupedSeasonsWithPrice);
    			var str = '';
    			str += '<table class="table pricelist table-hover table-bordered">';
    			str += '<thead>';
    			str += '<tr>';
    			str += '<th scope="col">Saison</th>';
    			str += '<th scope="col">Zeitraum</th>';
    			str += '<th scope="col">Preis 1. Nacht</th>';
    			str += '<th scope="col"></th>';
    			str += '</tr>';
    			str += '</thead>';

    			data.forEach((line) => {
    				str += '<tr>';
    				str += '<td>' + line.name + '</td>';
    				str += '<td>';
    				if (line.seasonPeriods) {
    					line.seasonPeriods.forEach((period) => {
    						str += period + '<br/>';
    					});
    				}
    				str += '</td>';

    				str += '<td>ab ' + line.firstNightPrice.toFixed(2).replace(".", ",") + ' &euro;';
    				//	str += '<br/><span class="small">Inklusive Miete, Endreinigung, Servicepauschale, Strom, Wasser, Wärme, WLAN und Parkplatz.</span>';
    				str += '</td>';
    				str += '<td>';
    				str += 'jede weitere Nacht ab ' + line.allNightPrice.toFixed(2).replace(".", ",") + ' &euro;'
    				str += '</td>';
    				str += '</tr>';

    			});

    			str += '</table>';

    			return str;
    		}


    	},
    	computed: {

    	}
    };
</script>